import { Component, Element, Host, h } from "@stencil/core";

@Component({
    tag: "ux-iws-nb-side-navigation-wrapper",
    styleUrl: "nb-side-navigation-wrapper.scss",
    shadow: false,
})
export class NbSideNavigationWrapper {
    @Element() host: HTMLUxIwsNbSideNavigationWrapperElement;

    componentDidLoad() {
        const sideNavigation = this.host.querySelector(
            "ux-iws-nb-side-navigation"
        );
        const firstContentElement = this.host.querySelector(
            "*:not(ux-iws-nb-side-navigation)"
        );
        const height = firstContentElement?.getBoundingClientRect().height || 0;
        const sideNavigationHeight =
            sideNavigation?.shadowRoot
                ?.querySelector(".inner")
                ?.getBoundingClientRect().height || 0;
        if (height === 0 || sideNavigationHeight === 0) {
            return;
        }
        firstContentElement.classList.add(
            "ux-iws-nb-side-navigation-wrapper__first-content-element"
        );
        this.host.style.setProperty(
            "--ux-iws-nb-side-navigation-wrapper--margin-top",
            `${height / 2 - sideNavigationHeight / 2}px`
        );
    }

    render() {
        return (
            <Host class="ux-iws-nb-side-navigation-wrapper">
                <slot></slot>
            </Host>
        );
    }
}
